import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    // Ignore DOM manipulation errors during logout/navigation - they don't break functionality
    const message = error.message || '';
    if (message.includes('removeChild') || message.includes('insertBefore')) {
      return { hasError: false, errorMessage: '' };
    }
    return { hasError: true, errorMessage: error.message || 'Unknown error' };
  }

  componentDidCatch(error, errorInfo) {
    const message = error.message || '';
    // Ignore DOM manipulation errors during navigation/transitions - they're harmless
    if (message.includes('removeChild') || message.includes('insertBefore')) {
      console.warn('⚠️ Ignored harmless DOM manipulation error during navigation:', message);
      return;
    }
    // Log full error details to console for debugging
    console.error('🔴 ERROR CAUGHT BY BOUNDARY:');
    console.error('Error:', error);
    console.error('Error message:', error.message);
    console.error('Error stack:', error.stack);
    console.error('Error info:', errorInfo);
    console.error('Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '100vh',
          padding: '20px',
          textAlign: 'center',
          backgroundColor: '#f8f9fa'
        }}>
          <h1 style={{ fontSize: '24px', marginBottom: '20px', color: '#333' }}>Ceva nu a mers bine</h1>
          <p style={{ marginBottom: '10px', color: '#666' }}>
            Aplicația a întâmpinat o eroare neașteptată.
          </p>
          <p style={{ 
            marginBottom: '30px', 
            color: '#999', 
            fontSize: '14px',
            maxWidth: '600px',
            wordBreak: 'break-word'
          }}>
            Eroare tehnică: {this.state.errorMessage}
          </p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => window.location.href = '/login'}
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                backgroundColor: '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Înapoi la Login
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Reîncarcă Pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
